import React from 'react';
import { FreightText as StyledFreightText } from './FreightText.styled';

export interface FreightTextProps {
  children: React.ReactNode;
  className?: string;
}

export function FreightText({ children, className }: FreightTextProps) {
  return (
    <StyledFreightText className={className}>
      {children}
    </StyledFreightText>
  );
}
